module.exports = __webpack_public_path__ + "static/src/content/images/processed/200/Jupiter-Ascending.b9b52ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/200/Jupiter-Ascending.jpg
// module id = vtW3
// module chunks = 0